(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Merchant', Merchant);

    Merchant.$inject = ['$resource'];

    function Merchant ($resource) {
        var resourceUrl =  'api/merchants/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    id: 'page'
                }
            },
            'getAll': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete':{
                method:'DELETE',
                params: {
                    login: 'id'
                }
            },
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {method:'GET',
                params:{
                    id:'exists'
                }
            },
            'getListByChannel': {
                method: 'GET',
                params: {
                    path: 'getListByChannel'
                },
                isArray: true
            }
        });
    }
})();
